<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import '../static/js/mui.min.js'
export default {
  name: 'App',
  mounted() {
    window.onresize = function() {
      document.activeElement.scrollIntoView(false)
    }
  }
}
</script>
<style>
.router-fade-enter-active, .router-fade-leave-active {
  transition: opacity .3s;
}
.router-fade-enter, .router-fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue